export default "__VITE_ASSET__DD97maYb__"